import React from 'react';
import { Grid } from '@mui/material';
import PhysiciansInfoBar from './physiciansInfoBar';
import DecilesAndSegments from './decilesAndSegments';
import PhysiciansTable from './physiciansTable';
import { useSelector } from 'react-redux';

const Physicians = () => {
    const { company } = useSelector((state) => state.company);
    const { userDetails: { is_admin } } = useSelector((state) => state.user);
    const showDecileAndSegment = [66,64,140,161].includes(company.id) && !is_admin;
    return (
        <> 
            <PhysiciansInfoBar />
            <Grid container spacing={'32px'}>
                {/* Overall Impact Analysis */}
                {
                    !showDecileAndSegment &&
                    <Grid item xs={12}>
                        <DecilesAndSegments />
                    </Grid>
                }
               
                {/* List of Physicians */}
                <Grid item xs={12}>
                    <PhysiciansTable />
                </Grid>
            </Grid>
        </>
    );
};

export default Physicians;
